import { render, staticRenderFns } from "./BootstrapGroup.vue?vue&type=template&id=7714d2d8"
import script from "./BootstrapGroup.vue?vue&type=script&lang=js"
export * from "./BootstrapGroup.vue?vue&type=script&lang=js"
import style0 from "./BootstrapGroup.vue?vue&type=style&index=0&id=7714d2d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports